<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45">
            JOSÉ MARÍA<br>
            ARGUEDAS <br>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio14/jose-maria-arguedas">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio14/jose-maria-arguedas">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio14/jose-maria-arguedas">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img width="100%" src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_img001.jpg">
</section>

<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-center  font-24">
                    JOSÉ MARÍA ARGUEDAS (1911-1969) NACIÓ EN LOS ANDES Y CRECIÓ ENTRE DOS MUNDOS: EL DE LOS HACENDADOS Y 
                    EL DE LOS CAMPESINOS. ESTA EXPERIENCIA LO MARCÓ PARA TODA LA VIDA. JUSTAMENTE SU OBRA LITERARIA ESCENIFICA 
                    LAS TENSIONES ENTRE ESTAS DOS CULTURAS, ENTRE DOS NACIONES, COMO ÉL LAS LLAMA. SU POESÍA, SUS CUENTOS Y 
                    SUS NOVELAS REVELAN UNA PROFUNDA PREOCUPACIÓN POR LA IDENTIDAD PERUANA Y LOS DIVERSOS CONFLICTOS QUE LA HAN FORJADO.
                    <br>
                </p>
                <p class="fontMS100 text-justify  font-24 text-gris">
                    <br>
                    Considerado uno de los más grandes narradores del siglo XX, Arguedas se dedicó además a la etnología, la recopilación 
                    de folklore, la traducción y la docencia. Gran parte de su obra se sustenta en una profunda admiración por la cultura 
                    andina popular. Como maestro de escuela rural, incitó a sus estudiantes a investigar sobre sus orígenes, y los motivó 
                    a documentar las costumbres y creencias de sus comunidades. A través de constantes investigaciones etnológicas también 
                    logró crear un extenso registro de los mitos, leyendas, cuentos, canciones, danzas y fiestas de la región andina. 
                    El conocimiento que tenemos sobre la obra de Arguedas se la debemos en gran parte a Sybila Arredondo, su viuda, quien donó 
                    el archivo de José María Arguedas a la Biblioteca Nacional del Perú. Este acervo contiene manuscritos de sus obras, sus publicaciones, 
                    libros y otros documentos relacionados con las diversas labores que realizó a lo largo de su vida. El presente recorrido por la vida 
                    y obra de este gran escritor se ha realizado a partir de este archivo y las colecciones Paul Rivet, Franklin Pease y Raúl Porras Barrenechea.
                    <br>
                </p>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris_Img">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3 bott">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            ARGUEDAS, <span class="fontMS300"> EDUCADOR </span>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS500 text-justify  font-24">
                    <br><br>
                    LA TRAYECTORIA PEDAGÓGICA DE JOSÉ MARÍA ARGUEDAS COMIENZA EN EL COLEGIO NACIONAL MATEO PUMACCAHUA DE 
                    SICUANI, DONDE TRABAJA COMO MAESTRO DE CASTELLANO Y GEOGRAFÍA ENTRE 1939 Y 1941. ALLÍ DESARROLLA SU 
                    PENSAMIENTO PEDAGÓGICO Y TAMBIÉN SU INTERÉS POR LA ETNOLOGÍA, TAL COMO SE PUEDE VER EN LA REVISTA 
                    <span class="fontMS500Italic">PUMACCAHUA</span> QUE PREPARA Y PUBLICA JUNTO CON SUS ESTUDIANTES DE SECUNDARIA.
                    <br>
                </p>
                <p class="text-justify  font-24">
                    <br>
                    Para contrarrestar la enseñanza impersonal y autoritaria que recibió de joven, Arguedas buscó inspirar 
                    curiosidad y pasión por el aprendizaje en sus estudiantes. Incorporó en sus clases, tanto la lectura como 
                    la creación literaria, y motivó a sus estudiantes a apreciar su identidad cultural y observar y documentar 
                    las tradiciones, costumbres e historia oral de sus comunidades. Asimismo, promovió la educación bilingüe y 
                    destacó la importancia del juego, canto y baile para la formación espiritual e intelectual.<br><br>

                    Estos valores estuvieron presentes a lo largo de su carrera pedagógica. Posteriormente se desempeñó 
                    como maestro de castellano en varios colegios nacionales en Lima (1942-1949), como funcionario del 
                    Ministerio de Educación (1947-1952) y como catedrático en la Universidad Nacional Mayor de San Marcos 
                    (1958-1968) y la Universidad Nacional Agraria de la Molina (1964-1969).
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-2">
                        <br>
                    </div>
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/79173" target="_blank">
                            <img class="imgNP" width="100%"
                                src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_img002.jpg">
                        </a>
                    </div>
                    <div class="col-sm-5 pt-4">
                        <div class="row">
                            <img width="100%" src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                        </div>
                        <div class="row">
                            <tr class="borderT">
                                <td>
                                    <i class="fas fa-volume-up font-24 p-3"></i>
                                </td>
                                <td class="p-3">
                                    <p class="fontMS700 text-justify font-16">
                                        IMPORTANCIA DEL <br>
                                        FOLKLORE <br>
                                        EN LA EDUCACIÓN
                                        <br>
                                        <span class="fontMS100Italic">José María Arguedas.</span>
                                    </p>
                                </td>
                            </tr>
                            <audio controls controlsList="nodownload">
                                <source src="/assets/audios/ImportanciaDelFolkloreEnLaEducacion.mp3" type="audio/mpeg">
                                Your browser does not support the audio element.
                            </audio>
                            <p>
                                <br>
                            </p>
                        </div>
                        <div class="row">
                            <img width="100%" src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                        </div>
                    </div>
                    <div class="col-sm-1">
                        <br>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA_RESALTE.png" width="100%">
                <p class="text-justify text-white fontMS500 font-24">
                    <br>
                    <span>
                        NO, NO HAY PAÍS MÁS DIVERSO, MÁS MÚLTIPLE EN VARIEDAD TERRENA Y HUMANA; TODOS LOS GRADOS DE
                        CALOR Y COLOR, DE AMOR Y ODIO, DE URDIMBRES Y SUTILEZAS, DE SÍMBOLOS UTILIZADOS E INSPIRADORES.
                    </span>
                </p>
                <p class="text-right fontMS300Italic font-24 text-white">
                    <span>
                        JOSÉ MARÍA ARGUEDAS, 1968.
                    </span>
                    <br>
                </p>
                <img src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA_RESALTE.png" class="reflejo"
                    width="100%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco_AL">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            ARGUEDAS, <span class="fontMS300"> ETNÓLOGO </span>
                        </p>
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS500 text-justify  font-24">
                    <br><br>
                    JOSÉ MARÍA ARGUEDAS SE SENTÍA PARTE DE DOS MUNDOS, EL OCCIDENTAL Y EL ANDINO. ANTE LA PÉRDIDA DE SU 
                    MADRE, LA AUSENCIA DE SU PADRE Y EL MALTRATO DE SU MADRASTRA, ARGUEDAS ENCONTRÓ REFUGIO ENTRE LOS 
                    INDÍGENAS QUE TRABAJABAN EN LA HACIENDA DONDE VIVÍA. ESA CONVIVENCIA INFLUYE EN SU VIDA Y EN SU 
                    VOCACIÓN; APRENDE, VALORA Y HACE SUYOS EL QUECHUA Y LAS COSTUMBRES INDÍGENAS ANDINAS.
                    <br>
                </p>
                <p class="text-justify font-24">
                    <br>
                    Esta identidad dual define su labor antropológica. Le permite traducir importantes fuentes 
                    históricas del quechua al castellano. Tal es así, que prepara emotivas ediciones bilingües 
                    de la elegía <span class="fontMS100Italic">Apu Inca Atawallpaman,</span> los mitos fundacionales 
                    de Huarochirí y el drama cusqueño <span class="fontMS100Italic">Ollantay</span>, entre otros. 
                    Al mismo tiempo, en sus ensayos resalta el impacto de la modernización y las grandes migraciones 
                    de los andes a la costa. Documenta la resistencia de tradiciones milenarias y la adaptación de prácticas artísticas.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-3">
                        <a href="http://hdl.handle.net/20.500.14428/79174" target="_blank">
                            <img class="imgNP" width="100%"
                                src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_img005.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3">
                        <a href="http://hdl.handle.net/20.500.14428/79324 " target="_blank">
                            <img class="imgNP" width="100%"
                                src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_img006.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3">
                        <a href="http://hdl.handle.net/20.500.14428/79193" target="_blank">
                            <img class="imgNP" width="100%"
                                src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_img007.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3">
                        <a href="http://hdl.handle.net/20.500.14428/79190" target="_blank">
                            <img class="imgNP" width="100%"
                                src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_img008.jpg">
                        </a>
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <div class="col-sm-6">
                        <img class="imgNP" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_img009.jpg">
                        <p class="fontMS100Italic text-justify">
                            Apolonia Dorregaray y José María Arguedas en Huancayo. 10 de abril de 1964. Fuente: Archivo
                            de Sixto Seguil Dorregaray y familia.
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-4">
                        <img width="100%" src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                        <br>
                        <tr>
                            <td>
                                <br> <i class="fas fa-volume-up font-24 p-3"></i>
                            </td>
                            <td>
                                <p class="fontMS700 text-justify font-16">
                                    <br>EL SUEÑO DEL PONGO <br>
                                    <span class="fontMS100Italic">José María Arguedas.</span>
                                </p>
                                <audio controls controlsList="nodownload">
                                    <source src="/assets/audios/El sueño del pongo.mp3" type="audio/mpeg">
                                    Your browser does not support the audio element.
                                </audio>
                            </td>
                        </tr>
                        <img style="margin-top: 0%;padding-top: 0%;" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                        <br>
                        <img width="100%" src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                        <br>
                        <tr>
                            <td>
                                <br><i class="fas fa-volume-up font-24 p-3"></i>
                            </td>
                            <td>
                                <p class="fontMS700 text-justify font-16">
                                    <br> CARNAVAL DE TAMBOBAMBA <br>
                                    <span class="fontMS100Italic">José María Arguedas.</span>
                                </p>
                                <audio controls controlsList="nodownload">
                                    <source src="/assets/audios/Carnaval de Tambobamba.mp3" type="audio/mpeg">
                                    Your browser does not support the audio element.
                                </audio>
                            </td>
                        </tr>
                        <img style="margin-top: 0%;padding-top: 0%;" width="100%"
                            src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                    </div>
                    <div class="col-sm-1"></div>
                </div>
                <p class="text-justify font-24">
                    <br>
                    En el ámbito de la música, su aporte es notable. Gracias a las nuevas tecnologías de su tiempo,
                    como la grabadora portátil, realiza un registro sonoro de los más destacados músicos andinos.
                    Sostiene estrecha amistad con danzantes de tijeras, intérpretes y músicos del arpa, charango y
                    violín. Para su entierro expresamente solicita que su amigo el violinista Máximo Damián toque
                    “La agonía de Rasu-Ñiti” y “Coca Quintucha”.
                    <br><br>
                </p>
                <img style="margin-top: 0%;padding-top: 0%;" width="100%"
                    src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                <br><br><br><br>
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            ARGUEDAS, <span class="fontMS300"> ESCRITOR </span>
                        </p>
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS500 text-center font-24">
                    <br><br>
                    PARA JOSÉ MARÍA ARGUEDAS, LA DIVERSIDAD CULTURAL Y LINGÜÍSTICA DEL PAÍS FUE UNA FUENTE 
                    INFINITA DE INSPIRACIÓN. EN SU POESÍA, CUENTOS Y NOVELAS HACE SENTIR LA NATURALEZA DE LOS 
                    ANDES, DANDO VIDA A LOS MITOS, CANCIONES Y DANZAS.
                    <br><br>
                </p>
                <p class="font-24">
                    Arguedas escribe poesía en quechua, a veces con traducción al castellano. En cambio, en su 
                    ficción, predomina el castellano, pero incorpora frases y expresiones del quechua, incluso 
                    busca traducir el modo de hablar andino para hacerlo llegar a un público más amplio.
                    <br><br>
                    De esa manera, busca representar el encuentro de las distintas culturas del país. Es un encuentro 
                    tenso, muchas veces violento, marcado por la opresión y, al mismo tiempo, por la resistencia de los 
                    indígenas. Sus personajes (el hacendado y los campesinos, el mestizo, el burócrata, el ingeniero, 
                    el negociante, el trabajador y el migrante) transitan en medio de conflictos de poder y de identidad. 
                    A través de sus obras, percibimos que Arguedas aspiraba a lograr una sociedad multicultural y libre de desigualdades.
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="row pt-5">
                            <div class="col-sm-6 pt-5 bottom_cel">
                                <p class="font-24 fontMS100Italic text-right">
                                    Pero ya en la cama, a solas, una pena negra, invencible, se apoderaba de mi alma, y
                                    lloraba dos, tres horas. Hasta que una noche mi corazón se hizo grande, se hinchó.
                                    El llorar no bastaba; me vencían la desesperación y el arrepentimiento.
                                </p>
                                <p class="font-24 text-right fontMS100Italic pt-5">
                                    <br><br>
                                    Desde las cumbres bajan cuatro ríos y pasan cerca del pueblo; en las cascadas, el
                                    agua blanca grita, pero los mistis no oyen. En las lomadas, en las pampas, en las
                                    cumbres, con el viento bajito, flores amarillas bailan, pero los mistis casi no ven.
                                </p>
                                <p class="font-24 text-right fontMS100Italic pt-5">
                                    <br>
                                    El pequeño público permaneció quieto. No se oían ruidos en el corral ni en los
                                    campos más lejanos. ¿Las gallinas y los cuyes sabían lo que pasaba, lo que
                                    significaba esa despedida?
                                </p>
                            </div>

                            <div class="c100">
                                <p class="font-24 fontMS100Italic text-right">
                                    Pero ya en la cama, a solas, una pena negra, invencible, se apoderaba de mi alma, y
                                    lloraba dos, tres horas. Hasta que una noche mi corazón se hizo grande, se hinchó.
                                    El llorar no bastaba; me vencían la desesperación y el arrepentimiento.
                                </p>
                                <p class="font-24 text-right fontMS100Italic">
                                    <br><br>
                                    Desde las cumbres bajan cuatro ríos y pasan cerca del pueblo; en las cascadas, el
                                    agua blanca grita, pero los mistis no oyen. En las lomadas, en las pampas, en las
                                    cumbres, con el viento bajito, flores amarillas bailan, pero los mistis casi no ven.
                                </p>
                                <p class="font-24 text-right fontMS100Italic">
                                    <br>
                                    El pequeño público permaneció quieto. No se oían ruidos en el corral ni en los
                                    campos más lejanos. ¿Las gallinas y los cuyes sabían lo que pasaba, lo que
                                    significaba esa despedida?
                                </p>
                            </div>
                            <div class="col-sm-6 pt-5">
                                <a href="http://hdl.handle.net/20.500.14428/79316 " target="_blank">
                                    <img width="100%"
                                        src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_img011.jpg">
                                </a>
                                <a href="http://hdl.handle.net/20.500.14428/79160 " target="_blank">
                                    <img class="pt-5" width="100%"
                                        src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_img013.jpg">
                                </a>
                                <div class="libro pt-5">
                                    <a target="_blank" class="enlace"
                                        href="https://bpdigital.bnp.gob.pe/info/la-agonia-de-rasu-niti-y-otros-cuentos-00188476">
                                        <img class="img-fluid mb-3" width="100%"
                                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_img015.jpg">
                                        <div class="overlay">
                                            <p class="fontMS100 text-center">
                                                Leer el relato completo en la <br>
                                                Biblioteca Pública Digital.<br>
                                            </p>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-6">
                                <a href="http://hdl.handle.net/20.500.14428/79194" target="_blank">
                                    <img class="pt-5" width="100%"
                                        src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_img010.jpg">
                                </a>
                                <a href="http://hdl.handle.net/20.500.14428/79195" target="_blank">
                                    <img class="pt-5" width="100%"
                                        src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_img012.jpg">
                                </a>
                            </div>
                            <div class="col-sm-6 bottom_cel">
                                <p class="font-24 fontMS100Italic pt-5">
                                    La noticia del censo había causado tal revuelo, como tempestad de granizo, entre
                                    todos los habitantes de Huanipaca. Los corazones de los escolares hervían de
                                    entusiasmo, pues ya empezaban a tener una noción de su importancia y significación.
                                </p>
                                <p class="font-24 fontMS100Italic pt-5">
                                    ¡Kausasianikun! Chay rumi, sacha, unu, mayu kuyusqanmantan; mayu muyurisqanmantan,
                                    wayra tususqanmantan, astawan hatunta, astawan yawar kallpata hapisiayku.
                                    ¡Hatarisianikun, qan rayku, apu sutiyki, apu wañuyniyki rayku!
                                    <br><br>
                                    ¡Estamos vivos; todavía somos! Del movimiento de los ríos y las piedras, de la danza
                                    de árboles y montañas, de su movimiento, bebemos sangre poderosa, cada vez más
                                    fuerte. ¡Nos estamos levantando, por tu causa, recordando tu nombre y tu muerte!
                                </p>
                            </div>
                            <div class="c100">
                                <p class="font-24 fontMS100Italic ">
                                    La noticia del censo había causado tal revuelo, como tempestad de granizo, entre
                                    todos los habitantes de Huanipaca. Los corazones de los escolares hervían de
                                    entusiasmo, pues ya empezaban a tener una noción de su importancia y significación.
                                </p>
                                <p class="font-24 fontMS100Italic ">
                                    ¡Kausasianikun! Chay rumi, sacha, unu, mayu kuyusqanmantan; mayu muyurisqanmantan,
                                    wayra tususqanmantan, astawan hatunta, astawan yawar kallpata hapisiayku.
                                    ¡Hatarisianikun, qan rayku, apu sutiyki, apu wañuyniyki rayku!
                                    <br><br>
                                    ¡Estamos vivos; todavía somos! Del movimiento de los ríos y las piedras, de la danza
                                    de árboles y montañas, de su movimiento, bebemos sangre poderosa, cada vez más
                                    fuerte. ¡Nos estamos levantando, por tu causa, recordando tu nombre y tu muerte!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row pt-3">
                    <div class="col-sm-2">
                        <br>
                    </div>
                    <div class="col-sm-8">
                        <!-- <img width="100%" src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_img016.jpg"> -->
                        <iframe width="100%" height="415" src="https://www.youtube.com/embed/whrbwzk1_aI"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                        <p class="fontMS100Italic font-12 mb-3">
                            Adaptación de La agonía de Rasu Ñiti realizada por Augusto Tamayo. CETUC, 1985.
                        </p>
                    </div>
                    <div class="col-sm-2">
                        <br>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-4">
                        <img width="100%" src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_img017.jpg">
                    </div>
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/79191" target="_blank">
                            <img class="imgAmazonia" width="100%"
                                src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_img018.jpg">
                        </a>
                    </div>
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/79192" target="_blank">
                            <img class="imgAmazonia" width="100%"
                                src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_img019.jpg">
                        </a>
                    </div>
                </div>
                <div class="row p-5">
                    <div class="col-sm-2">
                    </div>
                    <div class="col-sm-4">
                        <!-- <a [routerLink]="['/visor/ART-82']" target="_blank">
                        <img class="imgAmazonia" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_img020.jpg">
                        </a> -->
                        <div class="container-fluid">
                            <img src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU__LINEA2.jpg" width="100%">
                            <div class="col-sm-2">
                                <a href="http://hdl.handle.net/20.500.14428/79614" target="_blank"
                                    style="color: inherit; text-decoration:none;">
                                    <i class="fas fa-file-alt font-24 p-3"></i>
                                </a>
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-24">
                                    <a href="http://hdl.handle.net/20.500.14428/79614" target="_blank"
                                        style="color: inherit; text-decoration:none;">
                                        <span class="fontMS700"> Sebastián Salazar Bondy. </span><br>
                                        <span class="fontMS500Italic"> Arguedas: fe en el hombre. </span><br>
                                        <span> El Comercio (30 nov. 1961): p. 2. </span>
                                    </a>
                                </p>
                            </div>
                            <img src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU__LINEA2.jpg" width="100%">
                        </div>

                    </div>
                    <div class="col-sm-4">
                        <!-- <a [routerLink]="['/visor/ART-84']" target="_blank">
                        <img class="imgAmazonia" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_img021.jpg">
                        </a> -->
                        <div class="container-fluid">
                            <img src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU__LINEA2.jpg" width="100%">
                            <div class="col-sm-2">
                                <a href="http://hdl.handle.net/20.500.14428/79615" target="_blank"
                                    style="color: inherit; text-decoration:none;">
                                    <i class="fas fa-file-alt font-24 p-3"></i>
                                </a>
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-24">
                                    <a href="http://hdl.handle.net/20.500.14428/79615" target="_blank"
                                        style="color: inherit; text-decoration:none;">
                                        <span class="fontMS700"> Ariel Dorfman. </span><br>
                                        <span class="fontMS500Italic"> Arguedas y la epopeya americana. </span><br>
                                        <span>Amaru 11 (1969): 18-26. </span>
                                    </a>
                                </p>
                            </div>
                            <img src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU__LINEA2.jpg" width="100%">

                        </div>
                    </div>
                    <div class="col-sm-2">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            ARGUEDAS
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS300 text-center colorPrincipal  font-40" style="margin-bottom: 0%;">
                    EN SUS PROPIAS PALABRAS
                </p>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                </div>
                <p class="text-justify  font-24">
                    <br><br>
                    Al recibir el premio Inca Garcilaso de la Vega en 1968, José María Arguedas imparte un discurso 
                    de gran trascendencia en el que reflexiona sobre los principios y razones que motivan y guían 
                    su obra literaria. Describe la realidad peruana como diversa y compleja, como una sociedad 
                    dividida que exige acción y justicia. Siente que él como individuo encarna la fusión de estas 
                    dos naciones en conflicto, y es a través de su literatura que busca plasmar esta experiencia. 
                    En el discurso dice: «Intenté convertir en lenguaje escrito lo que era como individuo: un vínculo 
                    vivo, fuerte, capaz de universalizarse, de la gran nación cercada y la parte generosa, humana, de los opresores».
                    <br>
                </p>
                <div class="row p-5">
                    <div class="col-sm-3">
                        <br>
                    </div>
                    <div class="col-sm-6">
                        <a href="http://hdl.handle.net/20.500.14428/79619" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_img023.jpg">
                        </a>
                    </div>
                    <div class="col-som-3">
                        <br>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            EL ZORRO DE ARRIBA
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS700 text-center colorPrincipal font-40" style="margin-bottom: 0%;">
                    Y EL ZORRO DE ABAJO
                </p>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                </div>
                <div class="row">
                    <!-- <div class="col-sm-6 p-5">
                        <img width="100%" src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_img024.jpg">
                        <br><span class="fontMS100Italic">
                            Fotografía de Baldomero Pestana. Fuente: Fondo Riva-Agüero <br> Sección Visual
                            AHRA-IRA-PUCP.
                        </span>
                    </div> -->
                    <div class="col-sm-12">
                        <p class="fontMS500 font-24 ">
                            <br><br>
                            TRAS SU MUERTE EN 1969, JOSÉ MARÍA ARGUEDAS DEJA UNA NOVELA INCONCLUSA TITULADA 
                            <span class="fontMS500Italic">EL ZORRO DE ARRIBA Y EL ZORRO DE ABAJO</span>. 
                            LA BIBLIOTECA NACIONAL CUSTODIA UN DOCUMENTO MECANOGRAFIADO DE 36 HOJAS QUE CORRESPONDEN AL 
                            MANUSCRITO ORIGINAL.
                            <br>
                        </p>
                    </div>
                </div>
                <p class="text-justify  font-24">
                    La novela está ambientada en el puerto de Chimbote, escenario del auge de la pesca a fines de la 
                    década del setenta. La idea de escribirlo surge en Arguedas, cuando viajó a Chimbote en varias 
                    ocasiones para observar la creciente industria de harina de pescado que provocó nuevas migraciones 
                    de la sierra a la costa. Es a partir de estas experiencias que elaboró una novela inquietante en 
                    la que revela la explotación de los pescadores por las grandes empresas, y explora, además, la 
                    confluencia de los migrantes andinos y costeños. La obra fue publicada póstumamente en Argentina 
                    por la editorial Losada. El libro incluye el discurso del premio Inca Garcilaso de la Vega y una 
                    selección de sus diarios.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-3">
                    </div>
                    <div class="col-sm-3">
                        <a href="http://hdl.handle.net/20.500.14428/79320 " target="_blank">

                            <img class="imgAmazonia" width="100%"
                                src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_img025.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3">
                        <a href="http://hdl.handle.net/20.500.14428/79278" target="_blank">

                            <img class="imgAmazonia" width="100%"
                                src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_img026.jpg">
                        </a>
                    </div>
                    <div class="col-sm-3">
                    </div>
                </div>
                <p class="text-justify  font-24">
                    <br><br>
                    En el último mes de su vida, José María Arguedas le envía el manuscrito de <span
                    class="fontMS100Italic">El zorro de arriba y el zorro de abajo</span> al editor Gonzalo Losada e 
                    incluye una carta con indicaciones para su publicación póstuma. En esta carta reconoce que es un 
                    proyecto inconcluso, sobre todo, lamenta no haber podido terminar la segunda parte. Arguedas le 
                    indica al respecto: «Yo no dudo del valor de algunos capítulos (he alcanzado a recomponer el primero 
                    en estos días) y de la importancia documental del conjunto. No puedo aventurar un juicio definitivo, 
                    tengo dudas y entusiasmos».
                    <br><br>
                </p>
            </div>
        </div>
    </div>
</div>
<div class="fondoMorado">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <p class="text-white text-justify font-24">
                    En sus obras literarias, José María Arguedas exalta figuras del mundo andino como el danzante de
                    tijeras y recrea juegos tradicionales, mitos, canciones y fiestas. Estas imágenes no son de un
                    pasado lejano, sino del mismo contexto del autor. Ellas representan un país complejo en proceso de
                    transformación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            En “La agonía de Rasu-Ñiti”, Arguedas crea una atmósfera vívida para retratar el último
                            baile del danzante. ¿Qué elementos visuales, auditivos o táctiles identificas en la
                            narración?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            ¿Cuánto sabías de la figura del dansak? Indaga sobre el origen de esta tradición. ¿Cómo se
                            ha transformado en la actualidad?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            Arguedas visibiliza los conflictos socioeconómicos exacerbados por la modernización: la
                            construcción de carreteras, la industrialización de los puertos, la llegada de las mineras
                            transnacionales. ¿Te parece que estos conflictos están vigentes en la actualidad?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS100 font-24">
                    <br><br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Arguedas, J.M. (2011). </span><br>
                            <span class="fontMS100Italic text-gris">Nosotros los maestros. Selección, estudio preliminar
                                y notas de Wilfredo Kapsoli.
                            </span>
                            <span class="text-gris">Lima: Derrama Magisterial. </span><br>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=463251" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Escobar, A. (1999).</span><br>
                            <span class="fontMS100Italic text-gris">La guerra silenciosa en Todas las sangres. Patio de
                                Letras. </span>
                            <span class="text-gris"> Lima: UNMSM. </span><br>
                            <a href="https://sisbib.unmsm.edu.pe/Bibvirtual/libros/literatura/patio/avance/Indice.htm"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">García Liendo, J. (2012). </span><br>
                            <span class="fontMS100Italic text-gris">Las chicherías conducen al coliseo: José María
                                Arguedas, tecnología y música popular. </span>
                            <span class="text-gris">En: Revista de Crítica Literaria Latinoamericana Año 38(75):
                                149-170.</span><br>
                            <a href="https://as.tufts.edu/romancestudies/rcll/pdfs/75/149-170-Garc%C3%ADa-Liendo.pdf "
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Henríquez Puentes, P., & Ostria González, M. (2019). </span><br>
                            <span class="fontMS100Italic text-gris">El espacio de lo posible en “La agonía de Rasu Ñiti”
                                de José María Arguedas.
                            </span>
                            <span class="text-gris">En: Estudios filológicos (63): 65-80. </span><br>
                            <a href="https://scielo.conicyt.cl/scielo.php?script=sci_arttext&pid=S0071-17132019000100065"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Mamani Ccazo, M. (2019). </span><br>
                            <span class="fontMS100Italic text-gris">Pensamiento pedagógico de José María Arguedas
                                Altamarino en la obra Nosotros los maestros (Tesis de licenciatura).</span>
                            <span class="text-gris">Universidad Nacional de Altiplano, Puno. </span><br>
                            <a href="http://repositorio.unap.edu.pe/bitstream/handle/UNAP/12243/Mamani_Ccazo_Marleny.pdf?sequence=1&isAllowed=y "
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Pinilla, C.M., Portocarrero, G., Sagastegui, C., & Rivera, C. (eds.)
                                (2005). </span><br>
                            <span class="fontMS100Italic text-gris">Arguedas y el Perú de hoy. </span>
                            <span class="text-gris">Lima: SUR. </span><br>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=293153" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>